export default "__VITE_ASSET__DZLaV2bn__"